import { GetApp } from "@mui/icons-material";
import { Grid, MenuItem } from "@mui/material";
import { Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { downloadIetFile } from "../../../../../actions/importForms";
import { downloadFile } from "../../../../../utils/filesUtils";
import FormikForm from "../../../../commons/formik/formikForm";
import FormikSelect from "../../../../commons/formik/formikSelect";
import FeatureLabel from "../../../../commons/labels/FeatureLabel";
import { StyledImportIetForm } from "../../../../styled/form";
import DropZone from "../../../forms/dropZone/dropZone";

const validationSchema = Yup.object({
  artId: Yup.string().required("Campo obligatorio"),
});

const initialValues = {
  artId: "",
};

const ImportIetForm = ({ handleSubmit, setFile, file }) => {
  const dispatch = useDispatch();

  const arts = useSelector((state) => state.art.artsAdhered);

  const handleDownloadFile = async () => {
    await dispatch(downloadIetFile()).then((res) => {
      downloadFile(res.value.data, "ArchivoEjemploImportarIET.csv");
    });
  };

  return (
    <StyledImportIetForm.FormContainer>
      <FormikForm
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}>
        <Form>

          <Grid container spacing={1}>
            <Grid item xs={4}>
              <FormikSelect
                name="artId"
                value={initialValues.artId}
                label="Art"
                sx={{ marginBottom: 5 }}>
                {arts.map((art) => (
                  <MenuItem value={art.id} key={art.id}>
                    {art.nombre}
                  </MenuItem>
                ))}
              </FormikSelect>
            </Grid>

            <Grid item xs={12}>
              <StyledImportIetForm.DropzoneContainer>
                <DropZone
                  files={file}
                  setFiles={setFile}
                  loading={false}
                  configuration={{
                    oneFile: true,
                    fileMinSizeInBytes: 1,
                    typifyAttachmentFile: false,
                  }}
                  extension=".csv"
                  accept={{
                    "application/csv": [".csv"],
                  }}
                  dropzoneText="Arrastre el formulario en formato '.csv' aquí o haga click en el recuadro para adjuntarlo."
                />
              </StyledImportIetForm.DropzoneContainer>
            </Grid>

            <Grid
              item
              xs={6}
              component={StyledImportIetForm.DownloadFileButton}>
              <FeatureLabel
                labelText="ARCHIVO MODELO"
                icon={<GetApp />}
                onClick={handleDownloadFile}
                tooltipText="Descargar archivo"
              />
            </Grid>

            <Grid
              item
              xs={6}
              component={StyledImportIetForm.SubmitButtonContainer}>
              <StyledImportIetForm.ButtonStyled
                variant="contained"
                type="submit"
                color="secondary"
                disabled={!file || file.length === 0}>
                Procesar
              </StyledImportIetForm.ButtonStyled>
            </Grid>
          </Grid>
        </Form>
      </FormikForm>
    </StyledImportIetForm.FormContainer>
  );
};

export default ImportIetForm;
